import React, { Component } from 'react'

export default class TrainerProfilePage extends Component {
    constructor(props){
        super(props);
        this.state ={
            email: '',
            id:'',
            loadingError: false,
            loading: false
        }
    }
    
    componentDidMount(){
        this.setState({
            ...this.state,
            id: this.props.location.userId,
        })
    }
    render() {
       // console.log('PROPS TRAINER PROFILE PAGE', this.props)
       // console.log('STATE TRAINER PROFILE PAGE', this.state)
        return (
            <div>
                  Trainer Profile Page
            </div>
        )
    }
}
